const messenger = ($window) => {
  return $window.Messenger;
};

export default messenger;
